import { Box, Grid, Switch, Typography } from "@material-ui/core";

import Bold from "~/components/typography/bold";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const SwitchDescription = styled(Grid)`
  flex-shrink: 1;
`;

interface AMCIncludeCommentaryToggleProps {
  includeCommentary: boolean;
  onToggle: () => void;
}

const AMCIncludeCommentaryToggle: React.FC<AMCIncludeCommentaryToggleProps> = ({
  includeCommentary,
  onToggle,
}) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Bold variant="subtitle1" color="textSecondary">
        {t("createReport.includeCommentaryTitle")}
      </Bold>
      <Grid container alignItems="flex-start" spacing={1} wrap="nowrap">
        <SwitchDescription item>
          <Typography variant="subtitle1" color="textSecondary" noWrap>
            {t("createReport.includeCommentary")}
          </Typography>
        </SwitchDescription>
        <Grid item>
          <Switch
            size="small"
            color={"secondary"}
            checked={includeCommentary}
            onClick={onToggle}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AMCIncludeCommentaryToggle;
